import { useState, useEffect } from "react"
import { useNavigate, useLocation } from "react-router"
import { toast } from "react-toastify"
import dateFormat from "dateformat";
import { priority_list } from "../../Shared/List"
import Server from "../../Shared/Server"
import Spinner from "../../Shared/Spinner"
import {InputField, NullableInput} from "../../Shared/InputField"
import SelectField from "../../Shared/SelectField"
import AsyncSelectField from "../../Shared/AsyncSelect";

const UpdateTodoForm = (props) => {
    const [errors, setErrors] = useState({})
    const [isLoading, setIsLoading] = useState(false)
    const [categoryOptions, setCategoryOptions] = useState([])
    const [villageOptions, setVillageOptions] = useState([])
    const [zoneOptions, setZoneOptions] = useState([])
    const [technicianOptions, setTechnicianOptions] = useState([])
    const [priorityOptions, setPriorityOptions] = useState([])
    const [selectedVillage, setSelectedVillage] = useState(null);

    const [formData, setFormData] = useState({
        technician_id: "",
        category_id: "",
        village_id: "",
        zone_id: "",
        location_name: "",
        contact_number: 61,
        priority: "",
        remark: 0,
        date: new Date().toISOString().slice(0, 10),
        public_id: "",
    })
    const {technician_id, category_id, village_id, zone_id, location_name, contact_number, priority, remark, date, public_id} = formData

    const navigate = useNavigate()
    const location = useLocation()

    useEffect(() => {
        if(location.state){
            const {todo} = location.state
            const priority_obj = priority_list.find(priority => priority.name === todo.priority)

            // format report-date to march date input date format
            const date = dateFormat(new Date(todo.date), "yyyy-mm-dd");

            setFormData((prev) => ({
                ...prev,
                technician_id: todo.technician_id,
                category_id: todo.category_id,
                village_id: todo.village_id,
                zone_id: todo.zone_id,
                location_name: todo.location_name,
                contact_number: todo.contact_number,
                priority: priority_obj.id,
                remark: todo.remark,
                date: date,
                public_id: todo.public_id
            }))
        }

        if (selectedVillage?.value) {
            loadOptions('village-zones', '', setZoneOptions, selectedVillage.value).then((response) => {
                setZoneOptions(response.map(zone => ({
                    id: zone.value, 
                    key: zone.public_id, 
                    name: zone.label
                })));
            });
        }
        
    }, [selectedVillage]);

    const loadOptions = async (url, query, setOptions, villageId=null) => {
        const params = { q: query };
            
        if (url === 'village-zones' && villageId) {
            params.village_id = villageId; // Send village_id only when loading zones
        }

        const priorities = [{id: "", name: "-- Please choose priority --", key: ""}]
        
        priority_list.map(priority => (
            priorities.push({
                id: priority.id,
                key: priority.key,
                name: priority.name
            })
        ))
        setPriorityOptions(priorities)

        try {
            const response = await Server.get(`/options/${url}`, {params});
            setOptions(response.data);
            return response.data;
        } catch (error) {
            return [];
        }
    };

    const onChange = (e) => {
        setFormData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value
        }));

        // change zoneOptions when village is selected
        if (e.target.name === 'village_id'){
            setSelectedVillage(e.target);
        }
    }

    const onSubmit = (e) => {
        e.preventDefault()

        const priority_name = priority_list[formData.priority -1].name
        const payload = {category_id, technician_id, zone_id, location_name, contact_number, priority: priority_name, remark, date}
        updateTodo(payload)
    }
    
    // add todo
    const updateTodo = async (payload) => {
        setIsLoading(true)
        try {
            const response = await Server.put(`/todos/${public_id}`, payload)
            if (response.status === 200){
                toast.success('Successfully created')
                navigate('/todos')
                setIsLoading(false)
            }else{
                toast.error(response.data?.detail)
            }
        } catch (error) {
            setIsLoading(false)
            if(error.response.status === 401){
                navigate('/login')
            }else if (error.response.status === 422) {
                setErrors({})
                error.response?.data?.detail.map((err) => (
                    setErrors((prevState) => ({
                        ...prevState,
                        [err.loc[1]]: err.msg
                    }))
                ))
            }else if (error.response.status === 403){
                toast.error(error.response.data.detail);
                navigate('/');
            }else {
                toast.error(error.response.data.detail);
            }
        }
    }

    if(isLoading){
        return <Spinner/>
    }

  return (
    <>
        <div className="card">
            <div className="card-header bg-info p-2 justify-content-center">
                <h3 className="card-title">Update Todo Form</h3>
            </div>
            <div className="card-body">
                <form onSubmit={onSubmit}>
                    <div className="row">
                        <div className="col-md-4">
                            <AsyncSelectField
                                name="category_id"
                                label="Category"
                                value={category_id}
                                onChange={onChange}
                                loadOptions={(query) => loadOptions('todo-categories', query, setCategoryOptions)}
                                options={categoryOptions}
                                placeholder="Start typing to search..."
                                error={errors.category_id}
                            />
                        </div>
                        <div className="col-md-4">
                            <AsyncSelectField
                                name="technician_id"
                                label="Technician"
                                value={technician_id}
                                onChange={onChange}
                                loadOptions={(query) => loadOptions('technicians', query, setTechnicianOptions)}
                                options={technicianOptions}
                                placeholder="Start typing to search..."
                                error={errors.technician_id}
                            />
                        </div>
                        <div className="col-md-4">
                            <SelectField
                                name="priority"
                                label="Priority"
                                value={parseInt(priority)}
                                options={priorityOptions}
                                onChange={onChange}
                                error={errors.priority}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3">
                            <InputField
                                placeholder="Location Name"
                                name="location_name"
                                type="text"
                                label="Name"
                                value={location_name}
                                onChange={onChange}
                                error={errors.location_name}
                            />
                        </div>
                        <div className="col-md-3">
                            <InputField
                                placeholder="Todo Contact"
                                name="contact_number"
                                type="number"
                                label="Contact"
                                value={contact_number}
                                onChange={onChange}
                                error={errors.contact_number}
                            />
                        </div>
                        <div className="col-md-3">
                            <AsyncSelectField
                                name="village_id"
                                label="Village"
                                value={village_id}
                                onChange={onChange}
                                loadOptions={(query) => loadOptions('villages', query, setVillageOptions)}
                                options={villageOptions}
                                placeholder="Start typing to search..."
                                error={errors.village_id}
                            />
                        </div>
                        <div className="col-md-3">
                            <SelectField
                                name="zone_id"
                                label="Zone"
                                value={parseInt(zone_id)}
                                options={zoneOptions}
                                onChange={onChange}
                                error={errors.zone_id}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4">
                            <InputField
                                name="date"
                                type="date"
                                label="Date"
                                value={date}
                                onChange={onChange}
                                error={errors.date}
                            />
                        </div>
                        <div className="col-md-8">
                            <NullableInput
                                placeholder="Remark (Optional)"
                                name="remark"
                                type="text"
                                label="Remark"
                                value={remark}
                                onChange={onChange}
                                error={errors.remark}
                            />
                        </div>
                    </div>
                    <br/>
                    <div className="row">
                        <div className="col-md-12">
                            <input type="submit" className="btn btn-outline-info" value="Update Todo" style={{float: 'right'}}/>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <br/>
    </>
  )
}

export default UpdateTodoForm
